import * as React from 'react';
import { IS_BROWSER } from 'core/constants';
import useQuoraPixelId from '../../hooks/useQuoraPixelId';
import Pixel from '../Pixel';

type QuoraPixelProps = {
    pixelMode: 'global' | 'conversion';
};

export default function QuoraPixel({ pixelMode }: QuoraPixelProps) {
    const { enabled, pixelId } = useQuoraPixelId();
    const mode = pixelMode === 'global' ? 'ViewContent' : 'Generic';

    if (enabled && !!pixelId && IS_BROWSER) {
        const pixelUrl = `https://q.quora.com/_/ad/${pixelId}/pixel?tag=${mode}`;
        return (
            <Pixel
                height="1"
                width="1"
                style={{ display: 'none' }}
                src={pixelUrl}
                alt="quora_tracking_pixel"
                cookieType="marketing"
            />
        );
    }

    return null;
}
